import React from 'react'
import { Form, Select, Input } from '@surecompanies/core_components'
import { FieldGroup } from '../../PaymentDetailModal/PaymentDetailModal.styles'
import {
  StatusUpdateFormKey,
  StatusUpdateFormKeyLabels,
  ESCALATION_REASON_OPTIONS,
} from '../statusUpdate.type'

interface EscalationReasonFieldsProps {
  reasons?: readonly string[]
  isExplanationRequired?: boolean
}

export function EscalationReasonFields({
  reasons = ESCALATION_REASON_OPTIONS,
  isExplanationRequired = false,
}: EscalationReasonFieldsProps) {
  return (
    <>
      <FieldGroup style={{ gridColumn: '1 / -1' }}>
        <Form.Item
          name={StatusUpdateFormKey.ESCALATE_REASON}
          label={StatusUpdateFormKeyLabels[StatusUpdateFormKey.ESCALATE_REASON]}
          style={{ marginBottom: 0 }}
          rules={[
            {
              required: true,
              message: `${StatusUpdateFormKeyLabels[StatusUpdateFormKey.ESCALATE_REASON]} is required`,
            },
          ]}
        >
          <Select
            placeholder="Select escalation reason"
            style={{ width: '100%' }}
          >
            {reasons.map((r) => (
              <Select.Option key={r} value={r}>
                {r}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </FieldGroup>
      <FieldGroup style={{ gridColumn: '1 / -1' }}>
        <Form.Item
          name={StatusUpdateFormKey.ESCALATE_EXPLANATION}
          label={
            StatusUpdateFormKeyLabels[StatusUpdateFormKey.ESCALATE_EXPLANATION]
          }
          rules={
            isExplanationRequired
              ? [
                  {
                    required: true,
                    message: `${StatusUpdateFormKeyLabels[StatusUpdateFormKey.ESCALATE_EXPLANATION]} is required`,
                  },
                ]
              : undefined
          }
          style={{ marginBottom: 0 }}
        >
          <Input.TextArea
            rows={3}
            placeholder="Enter escalate explanation"
            style={{ resize: 'vertical' }}
          />
        </Form.Item>
      </FieldGroup>
    </>
  )
}
